import React, { FC, useState, FocusEvent, ChangeEvent } from 'react'
import { UseFormRegister } from 'react-hook-form';
import classNames from 'classnames';

export type TextAreaProps = {
  label: string;
  name: string;
  error: any;
  register: UseFormRegister<any>;
  maxLength: number;
  required?: boolean
}

export const TextArea: FC<TextAreaProps> = ({
  label,
  name,
  register,
  error,
  maxLength,
  required = false,
}) => {
  const [hasValue, setHasValue] = useState<boolean>(false);
  const [currentCharactersLength, setCurrentCharactersLength] = useState<number>(maxLength)

  const id = `input-${name}`;
  const hasError = error != undefined;
  const { onBlur, onChange, ...registerRest } = register(name);

  const handleBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    setHasValue(!!e.target.value)
    onBlur(e)
  }

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentCharactersLength(maxLength - e.target.value.length);
    onChange(e)
  }

  return (
    <div className="position-relative booking-narrow-item mt-3">
      <label className="d-block position-relative my-2">
        <textarea
          className="ps-1 py-1 pe-3 form-control form-control--fullwidth"
          {...registerRest}
          onChange={handleChange}
          onBlur={handleBlur}
          id={id}
          name={name}
          required={required}
          aria-describedby={'errorId-' + id}
          maxLength={maxLength}
        />
        <span className={classNames("mt-n1 input__label", {
          "input__label--focus": hasValue
        })} dangerouslySetInnerHTML={{__html: label}} />
        <span className="small-text input__characterLength">{currentCharactersLength} tegn igjen</span>
      </label>
      {error && error.message &&
        <div
          id={'errorId-' + id}
          className={classNames('input__support p-1 mb-2 mt-n2', {
            'input__support--error': hasError,
          })}
        >
          <p className="fs-6 input__supportText">{error && error.message}</p>
        </div>
      }
    </div>
  )
};
